export default __webpack_public_path__ + "static/media/SmallStars.432c385e.svg";